module.exports = __webpack_public_path__ + "static/media/forgetpasspic.76a9c6ac.png";